import React, { useState, useEffect } from 'react'

import { Grid, Typography, Box, Button } from '@mui/material';

import { CoreContext } from '../../../core/context/CoreContext';
import PageWaiting from '../../../core/components/PageWaiting';
import IconEnabled from '../../../core/components/layout/IconEnabled';
import IconDisabled from 'core/components/layout/IconDisabled';
import { useDispatch, useSelector } from 'react-redux';
import PharmaorderListTableHeader from './PharmaorderListTableHeader';
import PharmaorderListTableRow from './PharmaorderListTableRow';
import { setSelectedPharmaorderId } from 'store/slice/PharmaSlice';

export default function PharmaorderListTable({ payload }) {
  const INITIAL_ROW_COUNT = 30;
  const ROW_CHUNK_SIZE = 30;
  const SCROLL_LOAD_THRESHOLD_PX = 250;
  const dispatch = useDispatch();
  const { showloading } = React.useContext(CoreContext);
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [visibleRowCount, setVisibleRowCount] = useState(INITIAL_ROW_COUNT);
  const {userprofileInfo} = useSelector((state)=>state.headerslice)
  const {pharmaorderDashboard} = useSelector((state)=>state.pharmaslice);
  const {pharmaorderList, filterCriteria, sorting} = useSelector((state)=>state.pharmaslice.pharmaorderDashboard);
  const {productList} = useSelector((state)=>state.pharmaslice);
  const {rolename, username} = useSelector((state) => state.headerslice.userprofileInfo);
  // useEffect(() => {
  //   if (rows.length===0)
  //     setRows(payload.tableList);
  // }, [payload])
  
  useEffect(() => {
    if(pharmaorderList.length>0) {
      setRows(pharmaorderList);
    }
  },[pharmaorderList])
  useEffect(() => {
    console.log("Filter Criteria Changed: ", filterCriteria);
  }, [filterCriteria]);

  const handleRowClick = (rowId) => {
    //dispatch(setSelectedPharmaorderId(rowId));
    setRows(prevData =>
      prevData.map(item =>
        item.id === rowId ? { ...item, 'expand': !item.expand } : item
      )
    );
  }

  const getActionComponent = (rowObj) => {
    return <>
      { payload.actionList.map(actionObj=>{
        if (
            (
              actionObj.status===undefined || (
                  actionObj.status!==undefined && 
                  (actionObj.status==='' || (actionObj.status!=='' && actionObj.status.toLowerCase().includes(rowObj.orderstatus.toLowerCase())))
              )
            )
          && 
          (actionObj.role===undefined || actionObj.role!=undefined && (actionObj.role==='' || actionObj.role.includes(userprofileInfo.rolename)))
          
        )
        return <IconEnabled actionObj={actionObj} id={rowObj.id}/>})}
    </>
  }

  useEffect(() => {
    let filteredRows = pharmaorderList;

    if (filterCriteria) {
      if (filterCriteria.executivename && filterCriteria.executivename.trim() !== '') {
        filteredRows = filteredRows.filter(row =>
          (row.executivename || '').toLowerCase().includes(filterCriteria.executivename.trim().toLowerCase())
        );
      }
      if (filterCriteria.partyname && filterCriteria.partyname.trim() !== '') {
        filteredRows = filteredRows.filter(row =>
          (row.partyname || '').toLowerCase().includes(filterCriteria.partyname.trim().toLowerCase())
        );
      }
      if (filterCriteria.orderid && filterCriteria.orderid.trim() !== '') {
        filteredRows = filteredRows.filter(row =>
          (row.orderid || '').toString().toLowerCase() === (filterCriteria.orderid.trim().toLowerCase())
        );
      }
      if (filterCriteria.orderstatus && filterCriteria.orderstatus.trim() !== '') {
        filteredRows = filteredRows.filter(row =>
          (row.orderstatus || '').toLowerCase().includes(filterCriteria.orderstatus.trim().toLowerCase())
        );
      }
      if (filterCriteria.brandname && filterCriteria.brandname.trim() !== '') {
        // Find all product objects whose brandname matches the criteria
        const matchingProductOrderIds = productList
          .filter(product =>
            (product.brandname || '').toLowerCase().includes(filterCriteria.brandname.trim().toLowerCase())
          )
          .map(product => product.orderid);

        // Filter rows whose id is in the matching orderids
        filteredRows = filteredRows.filter(row =>
          matchingProductOrderIds.includes(row.id)
        );
      } 
    }

    // Sorting logic
    if (sorting && sorting.column) {
      filteredRows = [...filteredRows].sort((a, b) => {
        const aValue = a[sorting.column];
        const bValue = b[sorting.column];
        if (aValue == null && bValue == null) return 0;
        if (aValue == null) return sorting.asc ? -1 : 1;
        if (bValue == null) return sorting.asc ? 1 : -1;
        if (typeof aValue === 'number' && typeof bValue === 'number') {
          return sorting.asc ? aValue - bValue : bValue - aValue;
        }
        return sorting.asc
          ? aValue.toString().localeCompare(bValue.toString())
          : bValue.toString().localeCompare(aValue.toString());
      });
    }

    setRows(filteredRows);
  }, [pharmaorderList, filterCriteria, sorting]);

  useEffect(() => {
    setVisibleRowCount(INITIAL_ROW_COUNT);
  }, [rows]);

  const loadMoreRows = () => {
    setVisibleRowCount((current) => Math.min(current + ROW_CHUNK_SIZE, rows.length));
  };

  const handleTableScroll = (event) => {
    const target = event.currentTarget;
    if (target.scrollHeight - target.scrollTop - target.clientHeight <= SCROLL_LOAD_THRESHOLD_PX) {
      loadMoreRows();
    }
  };

  const visibleRows = rows.slice(0, visibleRowCount);

  return (
    <>
      <Grid container direction="column" sx={{ justifyContent: "flex-start", alignItems: "flex-start", }}>
        {/* <HEADER/> */}
        <Grid item sx={{ width: '100%', paddingBottom: .2 }}>
          {/* <HEADER - CONTAINER/> */}
          < PharmaorderListTableHeader/>
        </Grid>
        {/* <ROWS/> */}
        <Grid item sx={{ width: '100%' }}>
          <Box lg={12} sx={{ flexGrow: 1 }}>
            <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: '72vh' }} onScroll={handleTableScroll}>
              {/* <ROW CONTAINER/> */}
              <Grid container direction="column" sx={{ justifyContent: "flex-start", alignItems: "flex-start", width: '100%' }}>

              {visibleRows.map(obj => {
                    return (
                      < PharmaorderListTableRow key={obj.id} obj={obj} getActionComponent={getActionComponent} actionList={payload.actionList} handleRowClick={handleRowClick}/>
                    ) 
                })}

              {visibleRowCount < rows.length ? (
                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ width: '100%', backgroundColor: 'white' }}
                  padding={1}
                >
                  <Button size="small" variant="text" onClick={loadMoreRows}>
                    Load More
                  </Button>
                </Grid>
              ) : null}

{
                rows.length === 0 ?
                  <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ width: '100%', backgroundColor: '#fafafa' }}
                    padding={1}
                  >
                    <Typography sx={{ fontWeight: 'light', fontSize: 14 }}><i>
                      {userprofileInfo.rolename==='PHARMA_OMS_ACCOUNTS'?'No Order to Approve':'Order(s) not added yet'}</i></Typography>
                  </Grid>
                  : <></>
              }
                
               </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </>
  );


}
